const barColor = [
  "rgba(122, 196, 165, 1)",
  "rgba(60, 135, 134, 1)",
  "rgba(181, 58, 109, 1)",
];

const summaryBOptions = {
  maintainAspectRatio: false,
  plugins: {
    tooltip: {
      callbacks: {
        label: function(context){
          return context.dataset.label+": "+context.parsed.y+"%"
        }
      }
    },
    datalabels: {
      display: false
    },
    title: {
      display: true,
      text: "Percentage of Accurate and Consistent Dimensions Classifications by Framework",
      font: {
        size: 15
      }
    }
  },
  scales: {
    y: {
      min: 0,
      max: 100,
      ticks: {
        callback: function(value, index, values) {
          return value+"%";
        }
      }
    },
  },
};

const summaryBData = {
  labels: ["Total", "Autonomy", "Impact"],
  datasets: [
    {
      label: "A (no rubric)",
      backgroundColor: barColor[0],
      borderColor: barColor[0],
      data: [20,7,33],
      borderWidth: 1,
    },
    {
      label: "A (rubric)",
      backgroundColor: barColor[1],
      borderColor: barColor[1],
      data: [33,13,53],
      borderWidth: 1,
    },
    {
      label: "C (rubric)",
      backgroundColor: barColor[2],
      borderColor: barColor[2],
      data: [44,25,63],
      borderWidth: 1,
    }
  ],
};

export {summaryBData, summaryBOptions};